<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-row class="text-center" style="background: #fff;">
             <v-card-text>
                 <div  v-if="marchand">
                     <v-form  v-if="marchand._valide===false"  ref="form"  :lazy-validation="lazy"  enctype="multipart/form-data">
                         <v-container>
                             <v-alert  v-if="errors"  dense outlined :type="(errors.update_error)?'error':'success'">{{$t(errors.message)}}</v-alert>
                             <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                             <v-row>
                                 <v-col cols="12" sm="4">
                                     <v-text-field :rules="Web_SiteRules" v-model="editedItem._web_site" :label="$t('marchand.site_web')"  single-line solo ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field :rules="CompanyRules"  v-model="editedItem._company" :label="$t('marchand.company') "  single-line solo ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field   v-model="editedItem._acronyme" :label="$t('marchand.acronyme')" single-line solo  ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field :rules="[rules.required,rules.email]"  v-model="editedItem._email" :label="$t('marchand.email')"  single-line solo ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field   v-model="editedItem._base_url_site_web" single-line solo  :label="$t('marchand.base_url')"  ></v-text-field>
                                 </v-col>

                                 <v-col cols="12" sm="4" >
                                     <v-select :rules="CategorieRules" @change="categorieChanged"   v-model="editedItem._categorie_id" item-text="_name" item-value="_id" :items="category_marchands" :label="$t('marchand.categorie')" single-line solo  required></v-select>
                                 </v-col>
                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_checkout" :label="$t('marchand.url_checkout')" single-line solo  ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_success" :label="$t('marchand.url_success')" single-line solo ></v-text-field>
                                 </v-col>

                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_error" :label="$t('marchand.url_error')" single-line solo  ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="6">
                                     <v-select :rules="countryRules" @change="countryChanged"   v-model="editedItem.country" item-text="_name" item-value="_id" :items="countries" :label="$t('marchand.pays')" single-line solo  required></v-select>
                                 </v-col>
                             </v-row>
                         </v-container>
                     </v-form>
                     <v-form  v-else  ref="form"  :lazy-validation="lazy"  enctype="multipart/form-data">
                         <v-container>
                             <v-alert  v-if="errors"  dense outlined :type="(errors.update_error)?'error':'success'">{{$t(errors.message)}}</v-alert>
                             <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                             <v-row>
                                 <v-col cols="12" sm="4">
                                     <v-text-field  :rules="Web_SiteRules" v-model="editedItem._web_site" :label="$t('marchand.site_web')"  single-line solo readonly ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field :rules="CompanyRules"  v-model="editedItem._company" :label="$t('marchand.company') "  single-line solo readonly ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field   v-model="editedItem._acronyme" :label="$t('marchand.acronyme')" single-line solo readonly ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field :rules="[rules.required,rules.email]"  v-model="editedItem._email" :label="$t('marchand.email')"  single-line solo readonly ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field   v-model="editedItem._base_url_site_web" single-line solo  :label="$t('marchand.base_url')"  readonly></v-text-field>
                                 </v-col>

                                 <v-col cols="12" sm="4" >
                                     <v-select :rules="CategorieRules" @change="categorieChanged"   v-model="editedItem._categorie_id" item-text="_name" item-value="_id" :items="category_marchands" :label="$t('marchand.categorie')" single-line solo  readonly  ></v-select>
                                 </v-col>
                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_checkout" :label="$t('marchand.url_checkout')" single-line solo  readonly></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_success" :label="$t('marchand.url_success')" single-line solo readonly ></v-text-field>
                                 </v-col>

                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_error" :label="$t('marchand.url_error')" single-line solo readonly  ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="6">
                                     <v-select :rules="countryRules" @change="countryChanged"   v-model="editedItem.country" item-text="_name" item-value="_id" :items="countries" :label="$t('marchand.pays')" single-line solo readonly ></v-select>
                                 </v-col>
                             </v-row>
                         </v-container>
                     </v-form>

                 </div>
                 <div v-else >
                     <v-form   ref="form"  :lazy-validation="lazy"  enctype="multipart/form-data">
                         <v-container>
                             <v-alert  v-if="errors"  dense outlined :type="(errors.update_error)?'error':'success'">{{$t(errors.message)}}</v-alert>
                             <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>

                             <v-row>
                                 <v-col cols="12" sm="4">
                                     <v-text-field  v-model="editedItem._web_site" :label="$t('marchand.site_web')"  single-line solo ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field :rules="CompanyRules"  v-model="editedItem._company" :label="$t('marchand.company') "  single-line solo ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field   v-model="editedItem._acronyme" :label="$t('marchand.acronyme')" single-line solo  ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field :rules="[rules.required,rules.email]"  v-model="editedItem._email" :label="$t('marchand.email')"  single-line solo ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="4" >
                                     <v-text-field   v-model="editedItem._base_url_site_web" single-line solo  :label="$t('marchand.base_url')"  ></v-text-field>
                                 </v-col>

                                 <v-col cols="12" sm="4" >
                                     <v-select :rules="CategorieRules" @change="categorieChanged"   v-model="editedItem._categorie_id" item-text="_name" item-value="_id" :items="category_marchands" :label="$t('marchand.categorie')" single-line solo  required></v-select>
                                 </v-col>
                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_checkout" :label="$t('marchand.url_checkout')" single-line solo  ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_success" :label="$t('marchand.url_success')" single-line solo ></v-text-field>
                                 </v-col>

                                 <v-col cols="12" sm="6" >
                                     <v-text-field   v-model="editedItem._url_error" :label="$t('marchand.url_error')" single-line solo  ></v-text-field>
                                 </v-col>
                                 <v-col cols="12" sm="6">
                                     <v-select :rules="countryRules" @change="countryChanged"   v-model="editedItem.country" item-text="_name" item-value="_id" :items="countries" :label="$t('marchand.pays')" single-line solo  required></v-select>
                                 </v-col>
                             </v-row>
                         </v-container>
                     </v-form>

                 </div>
                 <v-card-actions>
                     <v-spacer></v-spacer>
                     <div v-if="marchand">
                         <v-btn  v-if="marchand._valide===false"  :disabled="!editedItem._web_site || !editedItem._company  || !editedItem._email || !editedItem._categorie_id || !editedItem.country || mis"   @click.prevent="update" color="primary" >{{$t('update')}}</v-btn>
                     </div>
                     <div v-else>
                     <v-btn   :disabled="!editedItem._company || !editedItem._email || !editedItem._categorie_id || !editedItem.country || mis"   @click.prevent="save" color="primary" >{{$t('save')}}</v-btn>
                     </div>
                 </v-card-actions>

                      </v-card-text>

        </v-row>
    </div>
</template>


<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "Marchands",
        data () {
            return {
                submitting:false,
                valid:true,
                lazy:false,
                errors:undefined,
                mis:false,
                search: '',
                countryHasChanged:false,
                dialog: '',
                categorieHasChanged:false,
                id:undefined,
                headers: [
                ],
                editedIndex: -1,
                editedItem: {
                    _user_id: '',
                    _web_site: '',
                    _company: '',
                    _acronyme: '',
                    country: '',
                    _email: '',
                    _base_url_site_web: '',
                    _categorie_id: '',
                    _url_checkout: '',
                    _url_success: '',
                    _url_error: '',
                    _created_at: 0,
                    _id:''
                },

                Web_SiteRules: [
                    v => !!v ||   this.$t('marchand.site_web_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                CompanyRules: [
                    v => !!v ||   this.$t('marchand.company_required'),
                ],
                AcronymeRules: [
                    v => !!v ||  this.$t('marchand.acronyme_required'),
                ],
                rules: {
                    required: value => !!value ||  this.$t('field_required'),
                    min: v => v!==undefined && v.length >= 8 || this.$t('min_8_caracters'),
                    match: v => v == this.password || this.$t('password_mismatch'),
                    email: v => (v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) ||  this.$t('invalid_email'),
                    tel: v => (v.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/g)) ||  this.$t('invalid_phone'),
                    //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
                },
                Base_url_siteRules: [
                    v => !!v ||   this.$t('marchand.base_url_required'),
                ],
                CategorieRules: [
                    v => !!v ||   this.$t('marchand.categorie_required'),
                ],
                Url_checkoutRules: [
                    v => !!v ||   this.$t('marchand.url_checkout_required'),
                ],
                Url_successRules: [
                    v => !!v ||   this.$t('marchand.url_success_required'),
                ],
                Url_errorRules: [
                    v => !!v ||    this.$t('marchand.url_error_required'),
                ],
                countryRules: [
                    v => !!v ||    this.$t('marchand.pays_required'),
                ],
            }
        },
        computed: {


            ...mapState('marchands/',['marchand']),
            ...mapState('category_marchands/',['category_marchands']),
            country:function () {
                return (this.user.country===null || this.user.country==undefined) ? {text:"Votre pays",value:"1"} :{text:this.user.country._name, value:this.user.country._id}
            },
            user : function(){
                return this.$store.getters.auth
            },
            formTitle () {
                return this.editedIndex === -1 ? this.$t('Nouvelle Marchand') : this.$t('Modifier Marchand')
            },
            ...mapState('countries/',['countries']),



        },
        mounted(){

            this.initialize()


        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            initialize () {
                this.$store.dispatch('category_marchands/getCategorie_Marchand').then(response => {
                    console.log('category_marchands',response)
                });

                this.$store.dispatch('marchands/getMarchandOne').then(response => {
                    console.log('Mon document',response)
                });
                if (this.marchand){
                    this.editedItem=this.marchand;
                }
            },
            countryChanged(){
                this.countryHasChanged = true;

            },
            editItem (item) {
                this.editedIndex = this.marchands.indexOf(item)
                this.marchand = Object.assign({}, item)
                this.id = item._id;
            },

            deleteItem (item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText:this.$t('delete'),
                    cancelButtonText: this.$t('cnacel'),
                    showCancelButton: true,
                    confirmButtonColor:'#29B3A6'

                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('marchands/deleteMarchand', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },

            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.marchand = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            categorieChanged(){
                this.categorieHasChanged = true;
            },

            save () {
                let responseObj = {};
                let Self = this;
                let data = new FormData();
                this.mis=true;

                    data.append("user_id",this.$store.getters.auth._id);
                    data.append("web_site",this.editedItem._web_site);
                    data.append("company",this.editedItem._company);
                    data.append("acronyme",this.editedItem._acronyme);
                    data.append("email",this.editedItem._email);
                    data.append("base_url_site_web",this.editedItem._base_url_site_web);
                    data.append("url_checkout",this.editedItem._url_checkout);
                    data.append("url_success",this.editedItem._url_success);
                    data.append("url_error",this.editedItem._url_error);
                    let cat = this.editedItem._categorie_id;
                    let pays = this.editedItem.country;

                if (this.marchand){
                    data.append("id",this.editedItem._id)
                }

                if ( this.categorieHasChanged){
                    data.append("_categorie_id",cat);
                }
                if ( this.countryHasChanged){
                    data.append("country",pays);
                }
                this.submitting=true;

                this.$store.dispatch('marchands/setMarchand',data).then((response)=>{
                    responseObj.update_error = response.error;
                    responseObj.message = response.message;
                    this.errors = responseObj;
                    this.submitting=false;
                    if (response.error) {
                        Self.toast('error',this.$t(response.message));
                    }
                    else{
                        Self.toast('warning',''+this.$t(response.message)+', rechargement en cours...');
                        location.reload()
                    }
                });

            },
            update () {
                let responseObj = {};
                let Self = this;
                let data = new FormData();
                this.mis=true;

                    data.append("user_id",this.$store.getters.auth._id);
                    data.append("web_site",this.editedItem._web_site);
                    data.append("company",this.editedItem._company);
                    data.append("acronyme",this.editedItem._acronyme);
                    data.append("email",this.editedItem._email);
                    data.append("base_url_site_web",this.editedItem._base_url_site_web);
                    data.append("url_checkout",this.editedItem._url_checkout);
                    data.append("url_success",this.editedItem._url_success);
                    data.append("url_error",this.editedItem._url_error);
                    let cat = this.editedItem._categorie_id;
                    let pays = this.editedItem.country;

                if (this.marchand){
                    data.append("id",this.editedItem._id)
                }

                if ( this.categorieHasChanged){
                    data.append("_categorie_id",cat);
                }
                if ( this.countryHasChanged){
                    data.append("country",pays);
                }
                this.submitting=true;

                this.$store.dispatch('marchands/update',data).then((response)=>{
                    responseObj.update_error = response.error;
                    responseObj.message = response.message;
                    this.errors = responseObj;
                    this.submitting=false;
                    if (response.error) {
                        Self.toast('error',this.$t(response.message));
                    }
                    else{
                        Self.toast('warning',''+this.$t(response.message)+', rechargement en cours...');
                        location.reload()
                    }
                });

            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },

            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>
    .circle-icon {
        background: #29B3A6;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-top: -30%;
        margin-left: 53%;
    }
    .circular--square {
        border-radius: 50%;
    }
    .circular--square {
        border-radius: 50% 50%;
        width: 170px;
        height: 170px;
        object-fit: contain;
    }
    .img-icon-holder{
        margin-left: 60%;
        padding: 8px;
        background-color: #29B3A6;
        border-radius: 50%;
    }
    /*.circular--portrait {
        position: relative;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border-radius: 50%;
    }

    .circular--portrait img {
        width: 100%;
        height: auto;
    }*/
</style>